import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { withLatestFrom, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { untilDestroyed } from 'ngx-take-until-destroy';

import { DocumentDownloadAction, ActionTypes } from '../../state/actions';
import { State } from '../../state/state';

@Component({
  selector: 'awp-document',
  templateUrl: './document.component.html'
})
export class DocumentComponent implements OnInit, OnDestroy {

  isLoading = true;

  constructor(
    private activateRoute: ActivatedRoute,
    private actions: Actions,
    private store: Store<State>) { }

  ngOnInit(): void {
    this.actions
      .pipe(
        ofType(ActionTypes.DOCUMENT_DOWNLOAD_SUCCESS, ActionTypes.DOCUMENT_DOWNLOAD_FAILURE),
        take(1)
      )
      .subscribe(p => {
        this.isLoading = false;
      });

    this.activateRoute.params
      .pipe(
        withLatestFrom(this.activateRoute.queryParams, this.activateRoute.data),
        untilDestroyed(this)
      )
      .subscribe(([params, queryParams, data]) => {
        if (params.documentType !== 'letter') {
          const value = {
            ...params,
            ...queryParams,
            ...data.theme,
            clientname: data.theme.themeId
          };
          this.store.dispatch(new DocumentDownloadAction(value));
        }
      });
  }

  ngOnDestroy(): void { }

}
